import { Component } from '@angular/core';
import { HeroEmpresarialComponent } from "../../hero-empresarial/hero-empresarial.component";

@Component({
  selector: 'app-hero-servicio-ambulancia',
  standalone: true,
  imports: [HeroEmpresarialComponent],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-servicio-ambulancia.component.css'
})
export class HeroServicioAmbulanciaComponent {
  name="Servicios de Ambulancia";
  description = "Participación en eventos, ferias, charlas, etc. donde se abordan temas de bienestar físico, mental y nutroicional, orientados a mejorar la salud de los empleados.";
  description2 = "";
  routeLogo = "assets/img/enterprise/menu/ambulanciaServicio.svg";
  routeImage = "assets/img/ambulancia/ambulanciaHeader.svg"
}
